import { render, staticRenderFns } from "./status_filter.vue?vue&type=template&id=1b745c21&"
import script from "./status_filter.vue?vue&type=script&lang=js&"
export * from "./status_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports